import React from "react";
import { Link } from "react-router-dom";
import { Flame, Loader2 } from "lucide-react";
import { AiAssetBadge } from "./AiAssetBadge";
import { AssetPricingBadge } from "./AssetPricingBadge";

/**
 * Phase 25b · Horizontal carousel of 8 trending assets (7-day sale_count desc).
 */
export function MarketplaceTrendingCarousel({ items = [], loading, onOpen }) {
  return (
    <section data-testid="mp-trending-carousel" className="space-y-3">
      <header className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-text-secondary mb-1">
            <Flame className="h-3 w-3 text-neutral-400" /> Trending — Last 7 days
          </div>
          <h2 className="text-lg font-semibold tracking-tight text-[var(--color-text-main)]">
            Best sellers this week
          </h2>
        </div>
      </header>
      {loading ? (
        <div className="flex items-center gap-2 text-xs text-text-secondary py-6">
          <Loader2 className="h-3 w-3 animate-spin" /> Loading trending…
        </div>
      ) : items.length === 0 ? (
        <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-8 text-center text-xs text-text-secondary">
          Nessun trending negli ultimi 7 giorni.
        </div>
      ) : (
        <div className="grid grid-flow-col auto-cols-[minmax(230px,1fr)] gap-3 overflow-x-auto pb-3 snap-x snap-mandatory">
          {items.slice(0, 8).map((it) => (
            <Link
              key={it.asset_id}
              to={`/marketplace/asset/${it.asset_id}`}
              onClick={() => onOpen && onOpen(it)}
              data-testid={`mp-trending-card-${it.asset_id}`}
              className="group snap-start rounded-2xl border border-[var(--color-border)] bg-[var(--color-card)] p-4 hover:border-neutral-400/60 transition-colors block"
            >
              <div className="flex items-center justify-between mb-2">
                <span className="inline-flex items-center gap-1 text-[9px] uppercase tracking-widest px-2 py-0.5 rounded-full bg-neutral-400/15 text-neutral-300 border border-neutral-400/40">
                  <Flame className="h-2.5 w-2.5" /> {it.sales_last_period || 0} sales
                </span>
                <AssetPricingBadge is_paid={it.is_paid} price_eur_cents={it.price_eur_cents} size="sm" />
              </div>
              <h3 className="text-sm font-semibold text-[var(--color-text-main)] line-clamp-2 group-hover:text-[var(--color-secondary)] transition-colors">
                {it.title}
              </h3>
              {(it.creator_type === "virtual" || it.ai_generated) && (
                <div className="mt-2">
                  <AiAssetBadge assetAiType={it.asset_ai_type} />
                </div>
              )}
              <p className="text-[11px] text-text-secondary mt-2 line-clamp-2 leading-snug">
                {it.description || ""}
              </p>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}

export default MarketplaceTrendingCarousel;
